export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M12 19.2a7.2 7.2 0 100-14.4 7.2 7.2 0 000 14.4zm0 1.8a9 9 0 100-18 9 9 0 000 18z\" clip-rule=\"evenodd\"/><path d=\"M12.975 15.525a.975.975 0 11-1.95 0 .975.975 0 011.95 0zm-2.1-7.05c0-.525.45-.975 1.125-.975s1.125.45 1.125.975c0 .523-.522 4.104-.525 4.125-.003.021-.086.525-.6.525s-.597-.504-.6-.524V12.6c-.003-.021-.525-3.602-.525-4.125z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};